// debug.js
const options = JSON.parse(`{"namespace":"Ovatu"}`)
const { debug, namespace } = options
if (debug) {
  console.log(`${namespace} options: `, options)
}